export default __webpack_public_path__ + "static/media/more_vert-black-18dp.40078f00.svg";